import { Check } from 'lucide-react';
import { T, SERIF } from '../theme';
import { OutcomeCard } from '../primitives';
import type { OverviewVM } from '../../formatters/deckContent';

interface Props {
  vm: OverviewVM;
}

/** Act 1 — Overview: headline block + outcome cards. */
export function ActOverview({ vm }: Props) {
  const metaParts = [
    vm.planDateLabel ? `Plan date ${vm.planDateLabel}` : null,
    vm.preparedBy ? `Prepared by ${vm.preparedBy}` : null,
  ].filter((p): p is string => !!p);

  return (
    <div style={{ height: '100%', overflowY: 'auto', background: T.bg }}>
      <div
        style={{
          maxWidth: 1080,
          margin: '0 auto',
          padding: '40px',
          minHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div style={{ display: 'grid', gridTemplateColumns: '1.25fr 1fr', gap: 48, alignItems: 'center' }}>
          <div>
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: 1.5,
                textTransform: 'uppercase',
                color: T.teal,
                marginBottom: 16,
              }}
            >
              {vm.planYear} Financial Plan
            </div>
            <h1
              style={{
                fontFamily: SERIF,
                fontSize: 50,
                fontWeight: 600,
                letterSpacing: '-0.01em',
                color: T.navy,
                margin: '0 0 18px',
                lineHeight: 1.05,
              }}
            >
              {vm.clientNames}
            </h1>
            {metaParts.length > 0 && (
              <div style={{ marginTop: 4, fontSize: 13, color: T.gray }}>{metaParts.join(' · ')}</div>
            )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {vm.lifestyle && (
              <OutcomeCard icon={<Check size={18} />} title="Maintain Lifestyle" value={vm.lifestyle.value} sub={vm.lifestyle.sub} />
            )}
            {vm.legacy && (
              <OutcomeCard icon={<Check size={18} />} title="Leave a Legacy" value={vm.legacy.value} sub={vm.legacy.sub} />
            )}
            {vm.totalPlanValue && (
              <OutcomeCard
                highlight
                title="Proposed Total Plan Value"
                value={vm.totalPlanValue.proposed}
                sub={vm.totalPlanValue.sub}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
